<template>
  <div class="ivu-row-flex-end ivu-row-flex" style="margin-left: -12px;margin-right: -12px;">
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="物料编码">
            <Input v-model="formItem.materiel_code" placeholder="请出入物料编码"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="物料名称">
            <Input v-model="formItem.materiel_name" placeholder="请输入物料名称"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="大类">
            <!-- <Input v-model="formItem.material_category" placeholder="请输入物料大类"></Input> -->
            <Select v-model="formItem.material_category"
                      value="formItem.material_category"
                      clearable
                      filterable>
                        <Option :value="item.Classification" v-for="item of CategorryList" :key="item.ClassificationID">{{item.Classification}}</Option>
                      </Select>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="类型">
            <Select v-model="formItem.material_type" clearable value="formItem.material_type">
                  <Option value="常规">常规</Option>
                  <Option value="非标">非标</Option>
            </Select>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="状态">
            <Select v-model="formItem.material_state" clearable value="formItem.material_state">
                  <Option value="正常">正常</Option>
                  <Option value="失效">失效</Option>
            </Select>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="属性汇总">
            <Input v-model="formItem.material_subclass" placeholder="请输入属性汇总"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80">
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem>
        <div style="float:right">
          <Button type="primary" style="margin-right:1rem" @click="QueryHandleClick">查询</Button>
          <Button style="margin-right:1rem" @click="ResetHandleClick">重置</Button>
          <a href="#" @click.prevent="changeLimit">
            {{formItem.switch}}
            <Icon v-if="formItem.switch === '展开'" type="ios-arrow-down" />
            <Icon v-if="formItem.switch === '收起'" type="ios-arrow-up" />
          </a>
        </div>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { MaterialCategory } from '../../../../api/Materiel.js'
import bus from './Bus.js'
export default {
  name: 'MaterialHeader',
  data () {
    return {
      formItem: {
        materiel_code: '',
        materiel_name: '',
        material_category: '',
        material_state: '',
        material_type: '',
        material_subclass: '',
        switch: '展开'
      },
      CategorryList: []
    }
  },
  mounted: function () {
    this.GetCategorryList()
  },
  methods: {
    // 获取大类信息
    GetCategorryList () {
      MaterialCategory().then(res => {
        if (res.IsSuccess) {
          this.CategorryList = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    changeLimit () {
      if (this.formItem.switch === '展开') {
        this.formItem.switch = '收起'
      } else { this.formItem.switch = '展开' }
    },
    // 重置点击事件
    ResetHandleClick () {
      this.formItem = {
        materiel_code: '',
        materiel_name: '',
        material_category: '',
        material_type: '',
        material_state: '',
        material_subclass: '',
        switch: this.formItem.switch
      }
      this.$emit('ResetHandleClick')
    },
    // 点击查询按钮事件回调
    QueryHandleClick () {
      let check = false
      if (this.formItem.materiel_code !== '') {
        check = true
      } else if (this.formItem.materiel_name !== '') {
        check = true
      } else if (this.formItem.material_category !== '') {
        check = true
      } else if (this.formItem.material_state) {
        check = true
      } else if (this.formItem.material_subclass !== '') {
        check = true
      } else if (this.formItem.material_type !== '') {
        check = true
      }
      if (check) {
        bus.$emit('QueryHandleClick', this.formItem)
      } else {
        this.$Modal.error({
          title: '请填写需要查询的条件',
          content: '请填写需要查询的条件'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@media (min-width: 576px) {
  .ivu-col-span-sm-24 {
    display: block;
    width: 100%;
  }
}
@media (min-width: 576px) {
  .ivu-col-span-xl-24 {
    float: left;
    flex: 0 0 auto;
  }
}
@media (min-width: 768px) {
    .ivu-col-span-md-12 {
      display: block;
      width: 50%;
   }
}
@media (min-width: 768px) {
  .ivu-col-span-xl-12 {
    float: left;
    flex: 0 0 auto;
  }
}
@media (min-width: 1200px) {
  .ivu-col-span-xl-8 {
    display: block;
    width: 33.33333333%;
   }
}
@media (min-width: 1200px) {
  .ivu-col-span-xl-8 {
    float: left;
    flex: 0 0 auto;
  }
}
.ivu-row-flex-end {
    justify-content: flex-end;
}
.ivu-row-flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
</style>
